import React, { useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useForm } from "react-hook-form";
import {
  errorToastify,
  successToastify,
} from "../../../Components/Common/Toaster";
import { updateProductType } from "../../../helpers/urlConfig/apiFunctions";
import { getSessionData } from "../../../helpers/sessionDetailsParser";
import errorResponseHandler from "../../../helpers/errorResponseHandler";

function ProductTypeEdit({
  modal_list,
  setmodal_list,
  tog_list,
  fetchData,
  currentProductType,
}) {
  const { register, handleSubmit } = useForm({
    defaultValues: currentProductType,
  });

  const [huidDisabled, setHuidDisabled] = useState(
    !currentProductType.huid ? true : false
  );

  const onSubmit = async (data) => {
    try {
      data.updated_by = getSessionData("user_id");
      if (
        (parseInt(data.stock) == 0 && parseInt(data.gram) > 0) ||
        (parseInt(data.stock) > 0 && parseInt(data.gram) == 0)
      ) {
        return errorToastify(
          "You can't update data to zero stocks or zero gram"
        );
      } else {
        const response = await updateProductType(data);
        if (response.statusCode === 200) {
          successToastify("Product Type updated successfully!");
          fetchData();
          setmodal_list(false);
        } else {
          errorResponseHandler(response);
        }
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  return (
    <Modal
      isOpen={modal_list}
      toggle={() => {
        tog_list();
      }}
      centered
    >
      <ModalHeader
        className="bg-light p-3"
        toggle={() => {
          tog_list();
        }}
      >
        {" "}
        Edit Product Type{" "}
      </ModalHeader>
      <form className="tablelist-form" onSubmit={handleSubmit(onSubmit)}>
        <ModalBody>
          <div className="mb-3">
            <label htmlFor="customername-field" className="form-label">
              Product Type Name
            </label>
            <input
              type="text"
              id="customername-field"
              className="form-control"
              placeholder="Enter Product Type Name"
              required
              {...register("product_type_name", {
                required: "Product Type Name is required",
              })}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="customername-field" className="form-label">
              HUID{" "}
              {huidDisabled ? (
                <span style={{ color: "red" }}> - It has pairing</span>
              ) : (
                <span></span>
              )}
            </label>
            <input
              type="text"
              id="customername-field"
              className="form-control"
              placeholder="Enter HUID"
              {...register("huid")}
              disabled={huidDisabled}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="customername-field" className="form-label">
              Grams
            </label>
            <input
              type="text"
              id="customername-field"
              className="form-control"
              placeholder="Enter Gram"
              required
              {...register("gram", {
                required: "Grams is required",
              })}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="model_name-field" className="form-label">
              Model Name
            </label>
            <input
              type="text"
              id="model_name-field"
              className="form-control"
              placeholder="Enter Model Name"
              {...register("model_name")}
            />
          </div>

          {/* <div className="mb-3">
            <label htmlFor="customername-field" className="form-label">
              Age
            </label>
            <input
              type="text"
              id="customername-field"
              className="form-control"
              placeholder="Enter Age"
              {...register("age")}
            />
          </div> */}

          <div className="mb-3">
            <label htmlFor="customername-field" className="form-label">
              Stock
            </label>
            <input
              type="text"
              id="customername-field"
              className="form-control"
              placeholder="Enter Stock"
              required
              {...register("stock", {
                required: "Stock is required",
              })}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="shop_name-field" className="form-label">
              Shop Name
            </label>
            <input
              type="text"
              id="shop_name-field"
              className="form-control"
              placeholder="Enter Shop Name"
              {...register("shop_name", {
                required: "Shop Name is required",
              })}
            />
          </div>

          <div className="mb-3">
            <label htmlFor={`purchase_date`} className="form-label">
              Purchase Date
            </label>
            <input
              type="date"
              id="date-field"
              className="form-control"
              placeholder="Enter Purchase Date"
              {...register("purchase_date", {
                required: "Purchase Date is required",
              })}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="hstack gap-2 justify-content-end">
            <button
              type="button"
              className="btn btn-light"
              onClick={() => setmodal_list(false)}
            >
              Close
            </button>
            <button type="submit" className="btn btn-success" id="add-btn">
              Edit Product Type
            </button>
            {/* <button type="button" className="btn btn-success" id="edit-btn">Update</button> */}
          </div>
        </ModalFooter>
      </form>
    </Modal>
  );
}

export default ProductTypeEdit;
